import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FormSpy } from 'react-final-form';
import Form from 'components/Form/Layout';
import InputFile from 'components/Form/FormInputFile';
import validateForm from 'utils/Validator';
import { yupProcessUploadFile } from 'utils/yupFields';

type Step3FormValues = { uploadFile?: File };

type Step3UploadProps = {
  onSubmit: ( values: Step3FormValues ) => void,
  initialValues?: Step3FormValues,
  onValuesChange?: ( values: Step3FormValues ) => void,
};

function Step3Upload( { onSubmit, initialValues, onValuesChange }: Step3UploadProps ) {
  const { t } = useTranslation();
  const validate = validateForm( yupProcessUploadFile );

  return (
    <Form
      initialValues={{ uploadFile: undefined, ...initialValues }}
      validate={validate}
      onSubmit={( values ) => onSubmit( values as Step3FormValues )}
      body={() => (
        <Row>
          <Col>
            <FormSpy
              subscription={{ values: true }}
              onChange={( { values } ) => {
                onValuesChange?.( values as Step3FormValues );
              }}
            />
            <InputFile
              field="uploadFile"
              label="admin.processes.uploadFile"
              placeholder="admin.processes.uploadFile"
              dropzoneOptions={{
                multiple: false,
                accept: ['.xlsx', '.xls'],
              }}
              classNames={{ formGroup: 'mb-3' }}
            />
            <Button
              variant="primary"
              className="btn--full-width mt-4"
              type="submit"
            >
              {t( 'admin.processes.next' )}
            </Button>
          </Col>
        </Row>
      )}
    />
  );
}

export default Step3Upload;
